import React, { useEffect, useRef, useState } from 'react';
import { ThreadLineBottom } from './SocialHeader.styles';
/**
 * 스레드 연결선 컴포넌트
 * 답글 스레드에서 트윗들을 시각적으로 연결하는 선을 표시합니다.
 */ const ThreadLine = ({ showTop, showBottom, avatarSize, avatarRef, headerRef })=>{
    const [bottomLineHeight, setBottomLineHeight] = useState('10rem');
    const threadLineRef = useRef(null);
    const [threadLineId] = useState(`thread-line-${Math.random().toString(36).substring(2, 9)}`);
    const halfAvatarSize = avatarSize / 2;
    // 스레드 라인 길이 계산 함수
    const calculateThreadLineHeight = (sourceElement, targetPosition)=>{
        if (!sourceElement) return;
        const sourceRect = sourceElement.getBoundingClientRect();
        const distance = Math.max(0, targetPosition.top - sourceRect.bottom);
        return distance + 16; // 여유 마진
    };
    useEffect(()=>{
        if (!showBottom) return;
        const registerThreadLine = ()=>{
            if (avatarRef.current) {
                window.dispatchEvent(new CustomEvent('thread-line-registered', {
                    detail: {
                        id: threadLineId,
                        element: avatarRef.current,
                        position: avatarRef.current.getBoundingClientRect()
                    }
                }));
            }
        };
        const handleThreadLineUpdate = (e)=>{
            const event = e;
            if (event.detail.targetId === threadLineId && avatarRef.current) {
                const targetPosition = event.detail.position;
                if (targetPosition) {
                    const height = calculateThreadLineHeight(avatarRef.current, targetPosition);
                    setBottomLineHeight(`${height}px`);
                }
            }
        };
        const handleViewportChange = ()=>{
            registerThreadLine();
        };
        // 이벤트 리스너 등록
        window.addEventListener('thread-line-update', handleThreadLineUpdate);
        window.addEventListener('scroll', handleViewportChange);
        window.addEventListener('resize', handleViewportChange);
        // ResizeObserver 설정
        let resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined' && headerRef.current) {
            resizeObserver = new ResizeObserver(()=>{
                registerThreadLine();
            });
            resizeObserver.observe(headerRef.current);
        }
        const timerId = setTimeout(registerThreadLine, 0);
        return ()=>{
            window.removeEventListener('thread-line-update', handleThreadLineUpdate);
            window.removeEventListener('scroll', handleViewportChange);
            window.removeEventListener('resize', handleViewportChange);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            clearTimeout(timerId);
        };
    }, [
        showBottom,
        threadLineId,
        avatarRef,
        headerRef
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showTop && /*#__PURE__*/ React.createElement("div", {
        className: "absolute w-[2px] bg-gray-400 dark:bg-gray-600 -top-4 z-[15]",
        style: {
            left: `${halfAvatarSize}px`,
            transform: 'translateX(-50%)',
            height: `calc(${halfAvatarSize}px + 1rem)`,
            boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.2)'
        }
    }), showBottom && /*#__PURE__*/ React.createElement(ThreadLineBottom, {
        ref: threadLineRef,
        height: bottomLineHeight,
        className: "absolute w-[2px] bg-gray-400 dark:bg-gray-600 z-[15] transition-height duration-200",
        style: {
            left: `${halfAvatarSize}px`,
            transform: 'translateX(-50%)',
            top: `${avatarSize}px`,
            boxShadow: '0 0 0 1px rgba(255, 255, 255, 0.2)'
        },
        "data-thread-line-id": threadLineId
    }));
};
export default ThreadLine;
